import { MrRogersNpanxxProps } from '../../shared/useMrRogersNpanxx/interfaces';
import useMrRogersNpanxx from '../../shared/useMrRogersNpanxx/useMrRogersNpanxx';

export function useMrRogersPhoneLocation(phoneNumber: string) {
  const result = useMrRogersNpanxx({ phoneNumber });
  let npaNxxLocation = '';
  if (result.isSuccess && result.data) {
    const { data } = result;

    const npaNxxCities: string[] = [];
    data.forEach((d: MrRogersNpanxxProps) => {
      const { city } = d;
      if (d.city && !npaNxxCities.includes(city)) {
        npaNxxCities.push(city);
      }
    });
    const npaNxxCitiesString: string = npaNxxCities.join(', ');
    const npaNxxState = data.map((d: MrRogersNpanxxProps) => d.state_code)[0];
    npaNxxLocation = [npaNxxCitiesString, npaNxxState]
      .filter(Boolean)
      .join(', ');
  }
  return ['Area code location', npaNxxLocation];
}
